
import Form from '@/ui-kit/components/form';
import FormField from '@/ui-kit/components/form/form-field';
import Icon from '@/ui-kit/components/icon';
import { FormFieldProperty } from '@/ui-kit/components/form/enums';
import { StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { ControlEventType, ControlType } from '@/ui-kit/components/form/controls/enums';
import { IconType, IconProperty } from '@/ui-kit/components/icon/enums';
import { InputFillType, InputSlotType } from '@/ui-kit/components/form/controls/shared/input/enums';
import {
  AutocompleteFilterStrategy,
  AutocompleteProperty,
} from '@/ui-kit/components/form/controls/components/autocomplete/enums';
import BaseForm from '../../mixins/BaseForm';
import FormProps from '../../mixins/FormProps';
import { SearchFormControlName } from './enums';
import SoldDataState from '../../../services/SoldDataState';

export default {
  name: 'SearchForm',
  components: {
    Form,
    FormField,
    Icon,
  },
  mixins: [BaseForm, FormProps],
  data() {
    return {
      SearchFormControlName,
      StyleSizeType,
      StyleColorSchemeType,
      InputSlotType,
      IconType,
      IconProperty,
      FormFieldProperty,
      ControlType,
      ControlEventType,
    };
  },
  computed: {
    searchAddressOptions() {
      return SoldDataState.value.searchAddressOptions;
    },
    addressAutocompleteProps() {
      return {
        [AutocompleteProperty.Name]: SearchFormControlName.Address,
        [AutocompleteProperty.FillType]: InputFillType.Underlined,
        [AutocompleteProperty.FilterStrategy]: AutocompleteFilterStrategy.Async,
        [AutocompleteProperty.SearchHandler]: this.searchHandler,
        [AutocompleteProperty.Options]: this.searchAddressOptions,
        [AutocompleteProperty.Placeholder]: 'Enter street address',
      };
    },
    addressControl() {
      return this.getControl(SearchFormControlName.Address);
    },
    address() {
      return this.addressControl?.value;
    },
  },
  methods: {
    async searchHandler(value) {
      const options = await this.loadOptionsHandler(value);

      this.setOptions(options);
    },
    handleAddressChange(value) {
      if (!value) {
        this.setOptions([]);
      }
    },
    setOptions(searchAddressOptions) {
      SoldDataState.patch({ searchAddressOptions });
    },
  },
};
